import { createResource, type RouteResource } from '@atlassian/react-resource-router';

export const RESOURCE_TYPE_SLA_METRICS = 'SLA_METRICS';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const slaMetricsDataResource: RouteResource<any> = createResource<any>({
	type: RESOURCE_TYPE_SLA_METRICS,
	getKey: ({ match }) => match.params.projectKey || '',
	getDataLoader: () =>
		import(
			/* webpackChunkName: "async-resource-sla-metrics", jiraSpaEntry: "async-resource-sla-metrics" */ './get-data'
		),
	maxAge: Infinity,
});
